import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerListComponent } from './customer-list/customer-list.component';
import { AddCustomerCardComponent } from './add-customer-card/add-customer-card.component';
import { AddCustomerAddressComponent } from './customer-info/add-customer-address/add-customer-address.component';
import { CustomerProfileComponent } from './customer-info/customer-profile/customer-profile.component';
import { UpdateCustomerAddressComponent } from './update-customer-address/update-customer-address.component';
import { UpdateCustomerComponent } from './update-customer/update-customer.component';
import { CustomerRoutingModule } from './customer.routing';
import { NgxPaginationModule } from 'ngx-pagination';
import { ModalModule } from 'ngx-bootstrap/modal';
import { FormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { CustomerInfoComponent } from './customer-info/customer-info.component';
import { CustomerOrderComponent } from './customer-info/customer-order/customer-order.component';
import { CustomerCardComponent } from './customer-info/customer-card/customer-card.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import { CustomerFeedbackComponent } from './customer-info/customer-feedback/customer-feedback.component';

@NgModule({
  declarations: [
    CustomerListComponent,
    AddCustomerCardComponent,
    AddCustomerAddressComponent,
    CustomerProfileComponent,
    UpdateCustomerAddressComponent,
    UpdateCustomerComponent,
    CustomerInfoComponent,

    CustomerOrderComponent,
    CustomerCardComponent,
    CustomerFeedbackComponent,
  ],
  imports: [
    CommonModule,
    CustomerRoutingModule,
    NgxPaginationModule,
    ModalModule,
    // BsModalRef,
    FormsModule,
    ToastrModule,
    Ng2SearchPipeModule,
    MatSortModule,
    MatTableModule
  ]
})
export class CustomerModule { }
